const css = `._0ey_jq__solid{border-bottom:1px solid}._0ey_jq__dashed{border-bottom:1px dashed}._0ey_jq__dotted{border-bottom:1px dotted}._0ey_jq__solidOnHover:hover{text-decoration:underline}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"dashed":"_0ey_jq__dashed","dotted":"_0ey_jq__dotted","solidOnHover":"_0ey_jq__solidOnHover","solid":"_0ey_jq__solid"};
